/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';


/**
* Enum class ReceiptTypeEnum.
* @enum {}
* @readonly
*/
export default class ReceiptTypeEnum {
    
        /**
         * value: 4685
         * @const
         */
        4685 = 4685;

    
        /**
         * value: 4941
         * @const
         */
        4941 = 4941;

    
        /**
         * value: 4686
         * @const
         */
        4686 = 4686;

    
        /**
         * value: 8515
         * @const
         */
        8515 = 8515;

    
        /**
         * value: 8776
         * @const
         */
        8776 = 8776;

    
        /**
         * value: 9042
         * @const
         */
        9042 = 9042;

    
        /**
         * value: 12616
         * @const
         */
        12616 = 12616;

    
        /**
         * value: 12626
         * @const
         */
        12626 = 12626;

    
        /**
         * value: 16717
         * @const
         */
        16717 = 16717;

    
        /**
         * value: 16718
         * @const
         */
        16718 = 16718;

    
        /**
         * value: 20803
         * @const
         */
        20803 = 20803;

    
        /**
         * value: 57652
         * @const
         */
        57652 = 57652;

    
        /**
         * value: 61763
         * @const
         */
        61763 = 61763;

    
        /**
         * value: 62019
         * @const
         */
        62019 = 62019;

    

    /**
    * Returns a <code>ReceiptTypeEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ReceiptTypeEnum} The enum <code>ReceiptTypeEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}


